const popWindow = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  try {
    GaodunJSBridge.call({
      handlerName: 'popWindow',
      ...options
    });
  } catch (e) {}
};
export default popWindow;